export default "__VITE_PUBLIC_ASSET__c97ed17a__"